import { render, staticRenderFns } from "./Discounts.vue?vue&type=template&id=5a0b6831&scoped=true"
import script from "./Discounts.vue?vue&type=script&lang=js"
export * from "./Discounts.vue?vue&type=script&lang=js"
import style0 from "./Discounts.vue?vue&type=style&index=0&id=5a0b6831&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0b6831",
  null
  
)

export default component.exports